import React, { useEffect } from "react";
import { useState } from "react";
import FIBtest from "./Listening/FIBtest.js";
import HIWtest from "./Listening/HIWtest.js";
import ReusableTest from "./Writing/ReusableTest.js";
import ReusableMutlipleAnswerTest from "./Reading/ReusableMutlipleAnswerTest.js.js";
import ReusableSingleAnswerTest from "./Reading/ReusableSingleAnswerTest.js";

import ModalBox from "../../../../components/Backend/MockTest/ModalBox.jsx";
import DownloadAlertDialog from "../../../../components/Backend/MockTest/DownloadAlertDialog.jsx";
import { useParams } from "react-router-dom";
function Listening(props) {
  const data = useParams();
  const {
    pause,
    setPause,
    setCategory,
    setIndex,
    listeningAnswer,
    listening,
    mockType,
    setCounterState,
    currentPage,
    setCurrentPage,
    setSave,
    setError,
    setCurrentQuestionStart,
    error,

    setIsDownloading,
    checkAnswerState,
    setPassSaveDataState,
    passSaveDataState,
    setListeningState,
    setSectionC,
    mockId,
    pteType,
  } = props;
  let [smc, setSmc] = useState(true);
  let [mc, setMc] = useState(true);
  let [hcs, setHcs] = useState(true);
  let [smw, setSmw] = useState(true);
  let [hiw, setHiw] = useState(true);
  let [fib, setFib] = useState(true);
  let [sst, setSst] = useState(true);
  let [wfd, setWfd] = useState(true);
  const isCore = pteType === "core";
  console.log(pteType, "PTE Type in Listening.jsx",isCore);

  const [currentCategory, setCurrentCategory] = useState();
  const [currentIndex, setCurrentIndex] = useState();

  const [downloadStart, setDownloadStart] = useState(true);

  const [smcAudio, setSmcAudio] = useState([]);
  const [mcAudio, setMcAudio] = useState([]);
  const [hcsAudio, setHcsAudio] = useState([]);
  const [smwAudio, setSmwAudio] = useState([]);
  const [hiwAudio, setHiwAudio] = useState([]);
  const [fibAudio, setFibAudio] = useState([]);
  const [sstAudio, setSstAudio] = useState([]);
  const [wfdAudio, setWfdAudio] = useState([]);

  const [audioReadyStatus, setAudioReadyStatus] = useState();
  useEffect(() => {
    setCategory(currentCategory);
    setIndex(currentIndex);
  }, [currentCategory, currentIndex, setIndex, setCategory]);

  useEffect(() => {
    if (!listening) {
      return;
    }
    if (listening.sst?.length === 0) {
      setSst(false);
    }
    if (listening.mc?.length === 0) {
      setMc(false);
    }
    if (listening.fib?.length === 0) {
      setFib(false);
    }
    if (listening.smc?.length === 0) {
      setSmc(false);
    }
    if (listening.smw?.length === 0) {
      setSmw(false);
    }
    if (listening.hiw?.length === 0) {
      setHiw(false);
    }
    if (listening.wfd?.length === 0) {
      setWfd(false);
    }
    // HCS exists in Academic only; Core skips it.
    if (isCore || listening.hcs?.length === 0) {
      setHcs(false);
    }
  }, [listening, isCore]);

  useEffect(() => {
    const done = !smc && !mc && !hcs && !hiw && !smw && !wfd && !sst && !fib;
    if (!done) {
      return;
    }

    if (typeof setListeningState === "function") {
      setListeningState(false);
    }
    if (typeof setSectionC === "function") {
      setSectionC(false);
    }
  }, [smc, mc, hcs, hiw, smw, wfd, sst, fib, setListeningState, setSectionC]);

  //fetching audio data from audio url
  useEffect(() => {
    if (downloadStart) {
      setDownloadStart(false);
      if (mockType != 1) {
        setIsDownloading(true);
      }

      setSmcAudio([]);
      setMcAudio([]);
      setHiwAudio([]);
      setFibAudio([]);
      setHcsAudio([]);
      setFibAudio([]);
      setSstAudio([]);
      setWfdAudio([]);
      setAudioReadyStatus("loading");
      let smcAudioArray = [];
      let mcAudioArray = [];
      let hcsAudioArray = [];
      let hiwAudioArray = [];
      let smwAudioArray = [];
      let fibAudioArray = [];
      let sstAudioArray = [];
      let wfdAudioArray = [];

      const fetchAudio = async (
        index,
        url,
        audioArray,
        setAudio,
        finish = false
      ) => {
        try {
          const response = await fetch(url);

          if (!response.ok) {
            throw new Error(`Failed to fetch audio from source`);
          }

          const audioData = await response.arrayBuffer();
          const audioBlob = new Blob([audioData], {
            type: response.headers.get("content-type"),
          });

          let audioUrl = URL.createObjectURL(audioBlob);
          audioArray[index] = audioUrl;
          setAudio((prev) => {
            let updateAudioArray = [...prev];
            updateAudioArray[index] = audioUrl;
            return updateAudioArray;
          });
          if (finish) {
            setAudioReadyStatus("finished");
          }
        } catch (error) {
          setAudioReadyStatus("failed");

          // Handle error, e.g., show an error message to the user
        }
      };

      for (let i = 0; i < listening.sst.length; i++) {
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/sst/" +
            listening.sst[i].media,
          sstAudioArray,
          setSstAudio
        );
      }
      for (let i = 0; i < listening.smc.length; i++) {
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/smc/" +
            listening.smc[i].media,
          smcAudioArray,
          setSmcAudio
        );
      }
      for (let i = 0; i < listening.mc.length; i++) {
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/mc/" +
            listening.mc[i].media,
          mcAudioArray,
          setMcAudio
        );
      }
      for (let i = 0; i < listening.hiw.length; i++) {
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/hiw/" +
            listening.hiw[i].media,
          hiwAudioArray,
          setHiwAudio
        );
      }
      for (let i = 0; i < listening.hcs.length; i++) {
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/hcs/" +
            listening.hcs[i].media,
          hcsAudioArray,
          setHcsAudio
        );
      }
      for (let i = 0; i < listening.smw.length; i++) {
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/smw/" +
            listening.smw[i].media,
          smwAudioArray,
          setSmwAudio
        );
      }
      for (let i = 0; i < listening.fib.length; i++) {
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/fib/" +
            listening.fib[i].media,
          fibAudioArray,
          setFibAudio
        );
      }
      for (let i = 0; i < listening.wfd.length; i++) {
        let finish;

        if (i === listening.wfd.length - 1) {
          finish = true;
        }
        fetchAudio(
          i,
          process.env.REACT_APP_BACKEND_URL +
            "storage/wfd/" +
            listening.wfd[i].media,
          wfdAudioArray,
          setWfdAudio,
          finish
        );
      }
    }
  }, [mockType, listening, downloadStart, setPause, setIsDownloading]);

  useEffect(() => {
    if (
      smcAudio.length === listening.smc.length &&
      mcAudio.length === listening.mc.length &&
      hcsAudio.length === listening.hcs.length &&
      smwAudio.length === listening.smw.length &&
      fibAudio.length === listening.fib.length &&
      hiwAudio.length === listening.hiw.length &&
      sstAudio.length === listening.sst.length &&
      wfdAudio.length === listening.wfd.length &&
      !smcAudio.includes(undefined) &&
      !mcAudio.includes(undefined) &&
      !hcsAudio.includes(undefined) &&
      !smwAudio.includes(undefined) &&
      !fibAudio.includes(undefined) &&
      !hiwAudio.includes(undefined) &&
      !sstAudio.includes(undefined) &&
      !wfdAudio.includes(undefined) &&
      audioReadyStatus === "finished"
    ) {
      //sorting check succeeded
      setAudioReadyStatus("succeeded");
      if (mockType != 1) {
        setIsDownloading(false);
      }
    }
  }, [
    setPause,
    audioReadyStatus,
    setIsDownloading,
    fibAudio,
    mcAudio,
    smcAudio,
    hcsAudio,
    smwAudio,
    hiwAudio,
    sstAudio,
    wfdAudio,
    listening,
    mockType,
  ]);

  useEffect(() => {
    if (audioReadyStatus !== "succeeded") {
      setPause(true);
    } else {
      setPause(false);
    }
  }, [audioReadyStatus, setPause]);

  return (
    <>
      {(audioReadyStatus === "loading" || audioReadyStatus === "finished") && (
        <ModalBox
          open={true}
          title={"Downloading Resources"}
          text={
            "Please wait a bit while we are downloading required resources."
          }
        />
      )}
      {audioReadyStatus === "failed" && <DownloadAlertDialog />}

      {audioReadyStatus === "succeeded" && (
        <>
          {smc && (
            <ReusableSingleAnswerTest
              testPost={listening.smc}
              answer={listeningAnswer?.smc}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setSmc}
              category="smc"
              mockId={data.id}
              audioArray={smcAudio}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              setCurrentQuestionStart={setCurrentQuestionStart}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              setPause={setPause}
              checkAnswerState={checkAnswerState}
            ></ReusableSingleAnswerTest>
          )}
          {!smc && mc && (
            <ReusableMutlipleAnswerTest
              testPost={listening.mc}
              answer={listeningAnswer?.mc}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setMc}
              category="mc"
              mockId={data.id}
              audioArray={mcAudio}
              setPause={setPause}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              setCurrentQuestionStart={setCurrentQuestionStart}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              checkAnswerState={checkAnswerState}
            ></ReusableMutlipleAnswerTest>
          )}
          {!smc && !mc && hcs && (
            <ReusableSingleAnswerTest
              testPost={listening.hcs}
              answer={listeningAnswer?.hcs}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setHcs}
              category="hcs"
              mockId={data.id}
              audioArray={hcsAudio}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              setCurrentQuestionStart={setCurrentQuestionStart}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              setPause={setPause}
              checkAnswerState={checkAnswerState}
            ></ReusableSingleAnswerTest>
          )}
          {!smc && !mc && !hcs && hiw && (
            <HIWtest
              testPost={listening.hiw}
              answer={listeningAnswer?.hiw}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setHiw}
              category="hiw"
              mockId={data.id}
              audioArray={hiwAudio}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              setCurrentQuestionStart={setCurrentQuestionStart}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              setPause={setPause}
              checkAnswerState={checkAnswerState}
            ></HIWtest>
          )}
          {!smc && !mc && !hcs && !hiw && smw && (
            <ReusableSingleAnswerTest
              testPost={listening.smw}
              answer={listeningAnswer?.smw}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setSmw}
              category="smw"
              mockId={data.id}
              audioArray={smwAudio}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              setCurrentQuestionStart={setCurrentQuestionStart}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              setPause={setPause}
              checkAnswerState={checkAnswerState}
            ></ReusableSingleAnswerTest>
          )}
          {!smc && !mc && !hcs && !hiw && !smw && wfd && (
            <ReusableTest
              mockType={mockType}
              testPost={listening.wfd}
              answer={listeningAnswer?.wfd}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setWfd}
              timerCounterDuration={""}
              mockId={data.id}
              setCurrentQuestionStart={setCurrentQuestionStart}
              // setDetailDuration={setDetailDuration}
              // detailDuration={detailDuration}
              // setDetailAnswer={setDetailAnswer}
              // detailAnswer={detailAnswer}
              setSectionC={setSectionC}
              setCounterState={setCounterState}
              setListeningState={setListeningState}
              setPause={setPause}
              pause={pause}
              category="wfd"
              audioArray={wfdAudio}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              checkAnswerState={checkAnswerState}
              pteType={pteType}
            ></ReusableTest>
          )}
          {!smc && !mc && !hcs && !hiw && !smw && !wfd && sst && (
            <ReusableTest
              testPost={listening.sst}
              answer={listeningAnswer?.sst}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setSst}
              mockId={data.id}
              timerCounterDuration={isCore ? 480 : 600}
              setCurrentQuestionStart={setCurrentQuestionStart}
              setPause={setPause}
              pause={pause}
              category="sst"
              audioArray={sstAudio}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              checkAnswerState={checkAnswerState}
              pteType={pteType}

            ></ReusableTest>
          )}
          {!smc && !mc && !hcs && !hiw && !smw && !wfd && !sst && fib && (
            <FIBtest
              testPost={listening.fib}
              answer={listeningAnswer?.fib}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setCategoryState={setFib}
              category="fib"
              audioArray={fibAudio}
              mockId={data.id}
              setListeningState={setListeningState}
              setSectionC={setSectionC}
              setSave={setSave}
              setCurrentCategory={setCurrentCategory}
              setCurrentIndex={setCurrentIndex}
              setCurrentQuestionStart={setCurrentQuestionStart}
              passSaveDataState={passSaveDataState}
              setPassSaveDataState={setPassSaveDataState}
              error={error}
              setError={setError}
              setPause={setPause}
              checkAnswerState={checkAnswerState}
              isCore={isCore}
              pteType={pteType}
            ></FIBtest>
          )}
        </>
      )}
    </>
  );
}

export default Listening;
